<template>
  <div id="app">
    <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  }
}
</script>
<style lang="less">
html {
  body {
    font-family: "PingFangSC", "helvetica neue", "hiragino sans gb", "arial",
      "microsoft yahei ui", "microsoft yahei", "sans-serif";
    font-size: 14px;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.85);
    background-color: #fafafc;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 100vh;
  }
  body.hide-home {
    .home-menu,
    .home-bottom {
      display: none;
    }
  }
}
body {
  .ivu-btn {
    border-radius: 0;
    font-size: 14px;
  }
  .ivu-btn-primary {
    background-color: @c-primary;
    border-color: @c-primary;
    &:hover {
      background-color: #8dabef;
      border-color: #8dabef;
    }
  }
  .zlr-btn-primary {
    width: 96px;
    height: 32px;
    background: @c-primary;
    color: #fff;
    border-radius: 2px;
    border: none;
    &:hover {
      color: #fff;
    }
  }
  .zlr-btn-primary:hover {
    background: @c-primary;
  }
  .zlr-btn-default {
    border: 1px solid #6589dd;
    border-radius: 2px;
    height: 32px;
    width: 96px;
    line-height: 1px;
    color: #6589dd;
  }
  .ivu-form .ivu-form-item-label,
  .ivu-input,
  .ivu-select-selected-value,
  .ivu-select-item,
  .ivu-select-input,
  .ivu-select-placeholder,
  .ivu-radio-wrapper {
    font-size: 14px !important;
  }
  .ivu-page-item-active {
    background: @c-primary;
    a {
      color: #fff;
    }
  }
  pre {
    font-size: 14px;
    font-family: "PingFangSC", "helvetica neue", "hiragino sans gb", "arial",
      "microsoft yahei ui", "microsoft yahei", "sans-serif";
    margin: 0;
    word-break: break-all;
    white-space: pre-wrap;
  }
  .ivu-time-picker-header {
    display: none;
  }
}
@font-face {
  font-family: PDI;
  src: url(https://res.zailairen.com/tech/PlayfairDisplay-Italic.ttf);
}
ul {
  list-style: none;
}
.zlr-cover {
  position: relative;
  // cursor: not-allowed;
}
.zlr-cover::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: #fff;
  opacity: 0.5;
  z-index: 100;
}
.zlr-dis-0 {
  margin-bottom: 0;
  position: relative;
}
.zlr-inlin-block {
  display: inline-block;
}
</style>
